__turbopack_context__.v({
  "appDownloadBadgeText": "styles-module__MjkGda__appDownloadBadgeText",
  "appDownloadBox": "styles-module__MjkGda__appDownloadBox",
  "appDownloadLogo": "styles-module__MjkGda__appDownloadLogo",
  "downloadAppBadges": "styles-module__MjkGda__downloadAppBadges",
});
